import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-fb",
  "use": "spr-fb-usage",
  "viewBox": "0 0 8.05 15.59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.05 15.59\" id=\"spr-fb\"><defs><style>#spr-fb .cls-1{fill:#545a5e}</style></defs><title>fb</title><g id=\"spr-fb_Слой_2\" data-name=\"Слой 2\"><path class=\"cls-1\" d=\"M8 .32l-.39 2.55a6 6 0 0 0-1.39-.2c-.67 0-1.27.23-1.27.9v1.94H7.7L7.51 8H4.95v7.6H1.72V8H0V5.51h1.72V3.84a4.45 4.45 0 0 1 .56-2.58A3.07 3.07 0 0 1 5 0a10.92 10.92 0 0 1 3.1.31\" id=\"spr-fb_Слой_1-2\" data-name=\"Слой 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/fb.svg
// module id = 257
// module chunks = 0